import * as yup from "yup";
import {toast} from "react-toastify";

export const isValidContactForm = async (form_data) => {
    const {
        name,
        mobile,
        email,
        subject,
        message
    } = form_data;

    const shape = {
        name: yup.string().required('وارد کردن نام الزامیست').min(3, "نام حداقل ۳ کاراکتر"),
        mobile: yup.string().required('وارد کردن شماره الزامیست').matches(/^[0-9]+$/, 'شماره همراه فقط شامل اعداد باشد').length(11),
        email: yup.string().email("ایمیل معتبر وارد کنید"),
        subject: yup.string().required('وارد کردن موضوع الزامیست').min(3, 'موضوع حداقل ۳ کاراکتر'),
        message: yup.string().required('وارد کردن توضیحات الزامیست').min(5, "توضیحات حداقل ۵ کاراکتر"),
    }

    const schema = yup.object().shape(shape);

    try {
        await schema
            .validate({
                name,
                mobile,
                email,
                subject,
                message
            }, {abortEarly: false})

        return {isValid: true, errors: null}
    } catch (e) {
        toast.error(e.inner[0].message);
        return  {isValid: false, errors: e}
    }
}
